import {
    ComponentManager,
    Control,
} from 'radpresentation.htmlclient.defaultviewextensions';
import type ExtensionEditorViewModel from '@/ViewModels/Controls/ExtensionEditorViewModel';
import layout from './ExtensionEditor.html?raw';

const CONTROL_NAME = 'extensioneditor';
const tabInfo = {
    0: 'props',
    1: 'assctns',
    2: 'edit',
    3: 'list',
};

class ExtensionEditor extends Control {
    private control: JQuery;

    constructor(
        private viewModel: ExtensionEditorViewModel,
        private element?: JQuery
    ) {
        super(viewModel, element);

        this.onWidgetCreated(() => {
            this.applyBindings(this.control, {
                controlName: CONTROL_NAME,
                locator: this.viewModel.locator,
            });
        });
    }

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.control != null) {
            return this.control;
        }

        this.control = this.element || $('<div>');

        let timerId = this.applyTemplate(layout, this.control);

        this.triggers[timerId].then(() => {
            this.widget(null);

            let $propertyTabContent = this.control.find(
                '.property_tab_content'
            );
            let $associationTabContent = this.control.find(
                '.association_tab_content'
            );
            let $editMaskTabContent = this.control.find(
                '.edit_mask_tab_content'
            );
            let $listViewTabContent = this.control.find(
                '.list_view_tab_content'
            );
            let tabContentsByIndex = [
                $propertyTabContent,
                $associationTabContent,
                $editMaskTabContent,
                $listViewTabContent,
            ];

            let $tabs = this.control.find('.tabs').children();
            let $propertyTab = $($tabs[0]);
            let $associationTab = $($tabs[1]);
            let $editTab = $($tabs[2]);
            let $listTab = $($tabs[3]);

            ExtensionEditor.activate($propertyTab, $propertyTabContent);
            ExtensionEditor.activate($associationTab, $associationTabContent);
            ExtensionEditor.deactivate($editTab, $editMaskTabContent);
            ExtensionEditor.deactivate($listTab, $listViewTabContent);

            $associationTab.hide();
            $associationTabContent.hide();

            $tabs.each((i, tab) => {
                this.addEventHandler('click', $(tab), () => {
                    $tabs.each((innerIndex, innerTab) => {
                        if (innerIndex !== i) {
                            ExtensionEditor.deactivate(
                                innerTab,
                                tabContentsByIndex[innerIndex]
                            );
                        }
                    });
                    ExtensionEditor.activate(tab, tabContentsByIndex[i]);
                });

                this.applyBindings($(tab), {
                    locator: this.defineComputed(() => {
                        return (
                            this.viewModel.locator() + '.' + tabInfo[i] + '.tab'
                        );
                    }),
                });
            });

            this.defineSubscription(
                this.viewModel.shouldShowPropertyTab,
                shouldShowPropertyTab => {
                    let tabToShow = shouldShowPropertyTab
                        ? $propertyTab
                        : $associationTab;
                    let tabToHide = shouldShowPropertyTab
                        ? $associationTab
                        : $propertyTab;
                    let contentToShow = shouldShowPropertyTab
                        ? $propertyTabContent
                        : $associationTabContent;
                    let contentToHide = shouldShowPropertyTab
                        ? $associationTabContent
                        : $propertyTabContent;

                    let tabToHideIsActive = tabToHide.hasClass('active');

                    tabToHide.hide();
                    tabToShow.show();

                    tabToShow.addClass(
                        tabToHideIsActive ? 'active' : 'inactive'
                    );
                    tabToShow.removeClass(
                        tabToHideIsActive ? 'inactive' : 'active'
                    );

                    if (tabToHideIsActive) {
                        contentToHide.hide();
                        contentToShow.show();
                    }
                }
            );
        });

        return this.control;
    }

    private static deactivate(tab: Element | JQuery, content: JQuery) {
        $(tab).addClass('inactive');
        $(tab).removeClass('active');
        content.hide();
    }

    private static activate(tab: Element | JQuery, content: JQuery) {
        $(tab).addClass('active');
        $(tab).removeClass('inactive');
        content.show();
    }
}

export default ExtensionEditor;
ComponentManager.setControl(
    'ExtensionEditor',
    ExtensionEditor,
    'RADExtensionManagerHTMLViewExtension'
);
ComponentManager.setControl(
    'ExtensionEditorControl',
    ExtensionEditor,
    'RADExtensionManagerHTMLViewExtension'
);
